import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../components/AuthContext';

type UseLogoutReturn = { logout: () => Promise<void> };
type UseLogout = () => UseLogoutReturn;

export const useLogout: UseLogout = () => {
  const { signOut } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    try {
      await signOut();
      sessionStorage.clear();
    } catch (error) {
      enqueueSnackbar(`Error: "${error.message}".`, {
        variant: 'error',
      });
    } finally {
      navigate('/logout');
    }
  }, [signOut, enqueueSnackbar, navigate]);

  return { logout };
};
